import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const storefrontLessonsPickerModalViewSelector = createSelector(
	[],
	() => ({
		title: localize('storefront_add_lessons_title'),
		subtitle: localize('storefront_add_lessons_subtitle'),
		placeholder: localize('storefront_add_lessons_placeholder'),
	})
)

export default storefrontLessonsPickerModalViewSelector
